/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Release_Dialog_DismissInputs */



/**
* | output |
* | --- |
* | "Got it" |
*
* @param {Release_Dialog_DismissInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const release_dialog_dismiss = /** @type {((inputs?: Release_Dialog_DismissInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Release_Dialog_DismissInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Verstanden")
	return /** @type {LocalizedString} */ ("Got it")
});